// extracted by mini-css-extract-plugin
export default {"container":"login_container__3sCCA","description":"login_description__2puii","links":"login_links__3R9xi"};